import Roles from '@/shared/utils/roles.js'
import ActionsForm from '@/shared/mixins/actionsForm'
import Tools from '@/components/tools/Tools'
import EmployeeRepository from '@/shared/http/repositories/configurations/employee'
import FormSearch from './search-form.js'

import GroupRepository from '@/shared/http/repositories/configurations/group'
import AccountRepository from '@/shared/http/repositories/configurations/account.js'
import ProductRepository from '@/shared/http/repositories/configurations/product.js'
import { JWTService } from '@/shared/services/jwt'
import BoardRepository from '@/shared/http/repositories/crm/board.js'
import PARepository from '../../../../shared/http/repositories/configurations/pa.js'
import RegionalRepository from '../../../../shared/http/repositories/configurations/regional.js'
import NxDatePicker from '@/components/forms/NxDatePicker.vue'

const createListObject = () => ({ listOptions: [], selected: [], selectedList: [] })

const bacenRisks = ['AA', 'A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'HH', 'NC']
const sicoobRisks = ['R1', 'R2', 'R3', 'R4', 'R5', 'R6', 'R7', 'R8', 'R9', 'R10', 'R11', 'R12', 'R13', 'R14', 'R15', 'R16', 'R17', 'R18', 'R19', 'R20', 'NAO SE APLICA']

const dataInitialState = {
  nome: null,
  document: null,
  boardId: null,
  numeroPA: null,
  nomeRegional: null,
  gerenteId: null,
  responsavelId: null,
  gruposResponsaveisId: null,
  produtosId: null,
  diasAtrasoInicio: null,
  diasAtrasoFinal: null,
  valorInicial: null,
  valorFinal: null,
  operacao: null,
  riscoSicoob: null,
  riscoBacen: null,
  interacao: null,
  dataInteracaoInicial: null,
  dataInteracaoFinal: null
}

const dataComponents = {
  employee: createListObject(),
  groups: createListObject(),
  responsible: createListObject(),
  groupResponsible: createListObject(),
  product: createListObject(),
  numberPA: createListObject(),
  regionalName: createListObject(),
  boardId: { listOptions: [], value: [], selectedList: [] },
  sicoobRisk: { listOptions: sicoobRisks, selected: null, selectedList: [] },
  bacenRisk: { listOptions: bacenRisks, selected: null, selectedList: [] }
}

export default {
  name: 'CardSearch',
  mixins: [ActionsForm],
  components: {
    NxDatePicker
  },
  data () {
    return {
      data: { ...dataInitialState },
      form: FormSearch,
      roles: Roles,
      permissions: null,
      selected: 'gerente',
      showFilterSocialMedia: false,
      showFilterAssociado: false,
      showFilterInstituicao: false,
      showFilterResponsavel: false,
      showFilterCobranca: false,
      showFilterProduct: false,
      showFilterInteracao: false,
      ...dataComponents
    }
  },
  props: {
    parentComponent: {
      type: Object
    }
  },
  created () {
    this.onClear()
    this.permissions = JWTService.GetRoles()
    this.onLoadGroups()
    this.onLoadEmployeesFromUser()
    // this.onLoadUser()
    this.onLoadProducts()
    this.onLoadBoards()
    this.onLoadPAs()
    this.onLoadRegionais()
  },
  methods: {
    onLoad () {
      this.onClearFilters()
      this.onCloseFilterAccordion()
    },
    hasRole (role) {
      var result = false
      if (this.permissions) {
        for (var i in this.permissions) {
          // if (this.permissions[i].role === role) {
          if (this.permissions[i] === role) {
            result = true
          }
        }
      }
      return result
    },
    onClearFilters () {
      this.numberPA.selected = null
      this.product.selected = null
      this.regionalName.selected = null
      this.employee.selected = null
      this.responsible.selected = null
      this.sicoobRisk.selected = null
      this.bacenRisk.selected = null
      this.boardId.value = null
      this.groupResponsible.selected = null
      Tools.SetFormDefaultValues(this.form)
      this.parentComponent.filters = null
      this.parentComponent.onReloadBoard()
    },
    onCloseFilterAccordion () {
      this.showFilterSocialMedia = false
      this.showFilterAssociado = false
      this.showFilterInstituicao = false
      this.showFilterResponsavel = false
      this.showFilterCobranca = false
      this.showFilterProduct = false
      this.showFilterInteracao = false
    },
    onFilter () {
      // check and handle undefined or null values in this.data
      for (let key in this.form) {
        if (this.data[key] === null || this.data[key] === undefined) {
          this.data[key] = {}
        }
      }

      Tools.SetValueToSave(this.form, this.data)
      this.onGetEmployeeAndResponsibleAndGroupAndBoardAndRisks()

      if (this.validateFilter()) {
        if (this.data.interacao !== undefined && this.data.interacao !== null) {
          this.data.interacao = this.data.interacao ? 1 : 0
        }
        this.$eventHub.emit('Filter', { filters: this.data })
      } else {
        this.$eventHub.emit('Filter', { filters: null })
      }
    },
    processIfDefined (item, processFunc) {
      return item !== undefined ? processFunc(item) : null
    },
    validateFilter () {
      if (this.data) {
        this.data.document = this.processIfDefined(this.data.document, value => value.toString().replace(/[^\d]+/g, ''))
        this.data.diasAtrasoInicio = this.processIfDefined(this.data.diasAtrasoInicio, value => value.toString())
        this.data.diasAtrasoFinal = this.processIfDefined(this.data.diasAtrasoFinal, value => value.toString())

        let fieldsToValidate = ['nome', 'boardId', 'document', 'numeroPA', 'nomeRegional', 'gerenteId', 'responsavelId', 'gruposResponsaveisId', 'produtosId', 'operacao', 'riscoSicoob', 'riscoBacen', 'numeroPA', 'interacao']
        if (fieldsToValidate.some(field => this.data[field]) || (this.data.diasAtrasoInicio && this.data.diasAtrasoFinal) || (this.data.valorInicial && this.data.valorFinal)) {
          return true
        }
        if (this.data.interacao !== null) {
          return true
        }
      }
      return false
    },
    mapSelectedToValue (component) {
      const selected = component.selected

      if (Array.isArray(selected) && selected.length > 0) {
        return selected.map(item => item.value)
      } else if (selected && typeof selected === 'object') {
        return selected.value
      } else {
        return null
      }
    },
    onGetEmployeeAndResponsibleAndGroupAndBoardAndRisks () {
      if (this.sicoobRisk.selected && this.sicoobRisk.selected.length === 0) this.sicoobRisk.selected = null
      if (this.bacenRisk.selected && this.bacenRisk.selected.length === 0) this.bacenRisk.selected = null

      this.data.gerenteId = this.mapSelectedToValue(this.employee)
      this.data.responsavelId = this.mapSelectedToValue(this.responsible)
      this.data.gruposResponsaveisId = this.mapSelectedToValue(this.groupResponsible)
      this.data.produtosId = this.mapSelectedToValue(this.product)
      this.data.boardId = this.boardId.value
      this.data.riscoSicoob = this.sicoobRisk.selected
      this.data.riscoBacen = this.bacenRisk.selected
      this.data.numeroPA = this.mapSelectedToValue(this.numberPA)
      this.data.nomeRegional = this.mapSelectedToValue(this.regionalName)
    },
    onLoadEmployee () {
      EmployeeRepository.GetAll()
        .then((res) => {
          this.responsible.listOptions = res.data.content.filter((x) => x.usuarioId != null).map((x) => ({'value': x.usuarioId, 'text': x.pessoa.nome}))
          this.employee.listOptions = res.data.content.filter((x) => x.usuarioId != null).map((x) => ({'value': x.id, 'text': x.pessoa.nome}))
        })
        .catch(this.onException)
    },
    onLoadGroups () {
      GroupRepository.GetAllActive()
        .then((res) => {
          this.groups.listOptions = res.data.content.filter((x) => x.id != null).map((x) => ({'value': x.id, 'text': x.nameGroup}))
          this.groupResponsible.listOptions = res.data.content.filter((x) => x.id != null).map((x) => ({'value': x.id, 'text': x.nameGroup}))
        })
    },
    onLoadEmployeesFromUser () {
      if (this.hasRole(this.roles.ADMINISTRADOR)) {
        this.onLoadEmployee()
      } else {
        AccountRepository.GetAllFromUser()
          .then((res) => {
            this.employee.listOptions = res.data.filter((x) => x.usuarioId != null).map((x) => ({'value': x.id, 'text': x.associado.pessoa.nome}))
            this.responsible.listOptions = res.data.filter((x) => x.usuarioId != null).map((x) => ({'value': x.id, 'text': x.associado.pessoa.nome}))
          })
          .catch(this.onException)
      }
    },
    onLoadProducts () {
      ProductRepository.GetAll()
        .then((res) => {
          this.product.listOptions = res.data.content.map((x) => ({'value': x.id, 'text': x.nome}))
        })
        .catch(this.onException)
    },
    onLoadBoards () {
      BoardRepository.GetAllTipoBoard('COBRANCA')
        .then((res) => {
          let activeOptions = res.data.content
            .filter((x) => x.id != null && x.arquivado !== true)
            .map((x) => ({'value': x.id, 'text': x.nome}))

          let filedOptions = res.data.content
            .filter((x) => x.id != null && x.arquivado === true)
            .map((x) => ({'value': x.id + '&boardArquivado=true', 'text': x.nome}))

          let options = [
            { value: '&boardArquivado=false', text: 'Todos ativos (Padrão)' },
            { value: '&boardArquivado=true', text: 'Todos arquivados' },
            {
              label: 'Quadros Ativos',
              options: activeOptions
            },
            {
              label: 'Quadros Arquivados',
              options: filedOptions
            }
          ]

          this.boardId.listOptions = options
        })
        .catch(this.onException)
    },
    onLoadPAs () {
      PARepository.GetAll()
        .then((response) => {
          let result = response.data.content
            .map((x) => ({'value': x.numero, 'text': x.descricao}))
          this.numberPA.listOptions = result
        })
        .catch(this.onException)
    },
    onLoadRegionais () {
      RegionalRepository.GetAll()
        .then((response) => {
          // CURRENTLY BEEN SET VALUE=NOME UNTIL BACKEND ACCEPTS MULTIPLE
          let result = response.data.content
            .map((x) => ({'value': x.nome, 'text': x.nome}))
          this.regionalName.listOptions = result
        })
        .catch(this.onException)
    }
  }
}



// WEBPACK FOOTER //
// ./src/views/private/cobranca/search/search.js